import LayoutView from './LayoutView';
import './LayoutView.scss';

export default LayoutView;
